module.exports = __webpack_public_path__ + "img/5-3.b61a837a.jpg";